export const globals = {
	servicesUrl: "https://services.statescape.com",
  corpUrl: "http://www.statescape.com",
  apiUrl: "https://sts.statescape.com",
  internalTitle: 'StateScape internal - ',
  clientTitle: 'StateScape - ',
};

// parameters which define location, used in requests
export const page = {
  legis: "L", // legislation track page
  regs: "R", // regulation track page
  local: "O", // local track page
  billFinder: "F", // bill finder page
  cmd: "C", // client management page
  cmdGN: "GN", // client management group notes
  dashboard: "D", // dashboard home location
  localReview: "OR", // local review page
  registerReview: "RR", // register review page
  legisNewRecordReview: "LNRR", // legis new record review page
  regsNewRecordReview: "RNRR", // regs new record review
  currentLegislation: "CL", // current legislation page
  sponsorInfo: "SI", // sponsor information page
  groupings: "G", // groupings page
  highlighter: "H", // highlighter page
  regsUrls: "RU", // regs urls page
  rawBillData: "RBD", // raw bill data page
  clientLocalities: "CLS", // client localities
  agencyEdit: "AE", // agency edit
  meetingDates: "MD", // meeting dates
  historyHelpText: "HHT", // history actions help text
  statusReview: "SR", // status review
  legisTrackInternal: "LTI", // internal legislation track page
  localTrackInternal: "LOTI", // internal local track page
  legislatorData: "LDP", // internal legislator data page
  aiTool: "AI", // internal ai tool
  legSessions: "LSS", // internal legislative sessions page
  regsTrackInternal: "RTI", // internal regs track page
  regsInjector: "RINJ", // internal regs injector (ingests StateScape Extractor data)
};

// static options for inputs for tracker pages
export const defaultSearchConstants = {
  options: [
    { value: "alltracked", label: "All Tracked Records" },
    { value: "active", label: "Active Records" },
    { value: "new", label: "New Records" },
    { value: "updated", label: "Updated Records" },
    { value: "newup", label: "New/Updated Records" },
  ],
  optionsUpdated: [
    { value: "alltracked", label: "All Tracked Records" },
    { value: "active", label: "Active Records" },
    { value: "new", label: "New Records" },
    { value: "updated", label: "Updated Records" },
    { value: "newup", label: "New/Updated Records" },
    { value: "newupnotes", label: "Updated Group Notes" },
  ],
  progress: {
    L: [
      {
        text: "Passed Committee",
        id: "pc",
        shortcut: "Passed Committee",
        type: "checkbox",
      },
      {
        text: "Passed House",
        id: "ph",
        shortcut: "Passed House",
        type: "checkbox",
      },
      {
        text: "Passed Senate",
        id: "ps",
        shortcut: "Passed Senate",
        type: "checkbox",
      },
      {
        text: "Passed House and Senate",
        id: "p_hs",
        shortcut: "Passed Senate",
        type: "checkbox",
      },
      {
        text: "Approved / Enacted",
        id: "app",
        shortcut: "Approved / Enacted",
        type: "checkbox",
      },
      {
        text: "Vetoed",
        id: "veto",
        shortcut: "Vetoed",
        type: "checkbox",
      },
      {
        text: "Died / Killed",
        id: "die",
        shortcut: "Died / Killed",
        type: "checkbox",
      },
    ],
    R: [
      {
        text: "Proposed",
        id: "Proposed",
        shortcut: "Proposed",
        type: "checkbox",
      },
      {
        text: "Published",
        id: "Published",
        shortcut: "Published",
        type: "checkbox",
      },
      {
        text: "Agency Adopted",
        id: "AgencyAdopted",
        shortcut: "Agency Adopted",
        type: "checkbox",
      },
      {
        text: "Finally Adopted",
        id: "FinallyAdopted",
        shortcut: "Finally Adopted",
        type: "checkbox",
      },
      {
        text: "Effective",
        id: "Effective",
        shortcut: "Effective",
        type: "checkbox",
      },
      {
        text: "Abandoned",
        id: "Abandoned",
        shortcut: "Abandoned",
        type: "checkbox",
      },
      {
        text: "Other Notices",
        id: "Other",
        shortcut: "Other Notices",
        type: "checkbox",
      },
      {
        text: "Emergency",
        id: "Emergency",
        shortcut: "Emergency",
        type: "checkbox",
      },
    ],
    O: [
      {
        text: "All",
        id: "all",
        shortcut: "All",
        type: "any_cb",
      },
      {
        text: "Introduced",
        id: "c0p",
        shortcut: "Introduced",
        type: "checkbox",
      },
      {
        text: "Adopted",
        id: "c1p",
        shortcut: "Adopted",
        type: "checkbox",
      },
      {
        text: "Died / Killed",
        id: "c2p",
        shortcut: "Died / Killed",
        type: "checkbox",
      },
      {
        text: "RFP Issued",
        id: "c3a",
        shortcut: "RFP Issued",
        type: "checkbox",
      },
      {
        text: "RFP Closed",
        id: "c4v",
        shortcut: "RFP Closed",
        type: "checkbox",
      },
    ],
  },
};

// constants for Regs types
export const RegsTypes = {
  Regs: "5",
};

// constants for Legis types
export const LegisTypes = {
  Legis: "1",
  "Legis Amend": "2",
  "Legis Enacted": "4",
};

// constants for screen sizes
export const screenSize = {
  extraSmall: 575,
  small: 767,
  medium: 991,
  large: 1199,
  specialSize: 1024,
};

// styles used to define edit, delete modals for subjects, favorites, users, clients, report line modals
export const values = {
  widthSubj: 500,
  paddingTablets: 155,
  paddingDesktop: 222,
  widthUsers: 800,
  findClientWidth: 700,
  managementToolsWidth: 1000,
  managementToolsHeight: 500,
  saveModalWidth: 620,
};
export const editDeleteStyles = {
  edit: {
    content: {
      left:
        window.innerWidth <= screenSize.extraSmall
          ? 10
          : // : window.innerWidth > screenSize.extraSmall &&
            //   window.innerWidth <= screenSize.specialSize
            //   ?
            (window.innerWidth - values.widthSubj) / 2,
      //: 400,
      right:
        window.innerWidth <= screenSize.extraSmall
          ? 10
          : window.innerWidth > screenSize.extraSmall &&
            window.innerWidth <= screenSize.specialSize
          ? (window.innerWidth - values.widthSubj) / 2
          : "auto",
      width:
        window.innerWidth <= screenSize.extraSmall ? "auto" : values.widthSubj,
      maxWidth:
        window.innerWidth <= screenSize.extraSmall ? "auto" : values.widthSubj,
      maxHeight: window.innerHeight * 0.8,
    },
  },
  delete: {
    content: {
      padding:
        window.innerWidth <= screenSize.extraSmall ? "35px 20px" : "35px 90px",
      left:
        window.innerWidth <= screenSize.extraSmall
          ? 10
          : // : window.innerWidth > screenSize.extraSmall &&
            //   window.innerWidth <= screenSize.specialSize
            //   ?
            (window.innerWidth - values.widthSubj) / 2,
      //: 400,
      right:
        window.innerWidth <= screenSize.extraSmall
          ? 10
          : window.innerWidth > screenSize.extraSmall &&
            window.innerWidth <= screenSize.specialSize
          ? (window.innerWidth - values.widthSubj) / 2
          : "auto",
      maxWidth:
        window.innerWidth <= screenSize.extraSmall ? "auto" : values.widthSubj,
    },
  },
  add: {
    overlay : {
    },
    content: {
      left:
        window.innerWidth <= screenSize.medium
          ? 10
          : (window.innerWidth - values.widthUsers) / 2,
      right:
        window.innerWidth <= screenSize.medium
          ? 10
          : (window.innerWidth - values.widthUsers) / 2,
      width:
        window.innerWidth <= screenSize.medium ? "auto" : values.widthUsers,
      maxWidth:
        window.innerWidth <= screenSize.medium ? "auto" : values.widthUsers,
    },
  },
  findClient: {
    content: {
      overflow: "hidden",
      left:
        window.innerWidth <= screenSize.small
          ? 10
          : (window.innerWidth - values.findClientWidth) / 2,
      right:
        window.innerWidth <= screenSize.small
          ? 10
          : (window.innerWidth - values.findClientWidth) / 2,
      maxWidth:
        window.innerWidth <= screenSize.small ? "auto" : values.findClientWidth,
      width:
        window.innerWidth <= screenSize.small ? "auto" : values.findClientWidth,
    },
  },
  managementTools: {
    content: {
       left:
        window.innerWidth <= screenSize.specialSize
          ? 10
          : (window.innerWidth - values.managementToolsWidth) / 2,
      right:
        window.innerWidth <= screenSize.specialSize
          ? 10
          : (window.innerWidth - values.managementToolsWidth) / 2,
      width:
        window.innerWidth <= screenSize.specialSize
          ? "auto"
          : values.managementToolsWidth,
      maxWidth:
        window.innerWidth <= screenSize.specialSize
          ? "auto"
          : values.managementToolsWidth,
      maxHeight: window.innerHeight * 0.8,
    },
  },
  saveAlertModal: {
    overlay : {
    },
    content: {
       left:
        window.innerWidth <= screenSize.specialSize
          ? 10
          : (window.innerWidth - values.saveModalWidth) / 2,
      right:
        window.innerWidth <= screenSize.specialSize
          ? 10
          : (window.innerWidth - values.saveModalWidth) / 2,
      width:
        window.innerWidth <= screenSize.specialSize
          ? "auto"
          : values.saveModalWidth,
      maxWidth:
        window.innerWidth <= screenSize.specialSize
          ? "auto"
          : values.saveModalWidth,
      maxHeight: window.innerHeight * 0.8,
    },
  },
  alertModal: {
    content: {
      padding: "35px 20px",
      fontFamily: "GothamMedium",
      textTransform: "none",
      letterSpacing: 1,
      left:
        window.innerWidth <= screenSize.extraSmall
          ? 10
          : // : window.innerWidth > screenSize.extraSmall &&
            //   window.innerWidth <= screenSize.specialSize
            //   ?
            (window.innerWidth - values.widthSubj) / 2,
      //: 400,
      right:
        window.innerWidth <= screenSize.extraSmall
          ? 10
          : window.innerWidth > screenSize.extraSmall &&
            window.innerWidth <= screenSize.specialSize
          ? (window.innerWidth - values.widthSubj) / 2
          : "auto",
      maxWidth:
        window.innerWidth <= screenSize.extraSmall ? "auto" : values.widthSubj,
    },
  },
  createTall: {
    content: {      
      left:
        window.innerWidth <= screenSize.extraSmall
          ? 10
          : // : window.innerWidth > screenSize.extraSmall &&
            //   window.innerWidth <= screenSize.specialSize
            //   ?
            (window.innerWidth - values.widthSubj) / 2,
      //: 400,
      right:
        window.innerWidth <= screenSize.extraSmall
          ? 10
          : window.innerWidth > screenSize.extraSmall &&
            window.innerWidth <= screenSize.specialSize
          ? (window.innerWidth - values.widthSubj) / 2
          : "auto",
      width:
        window.innerWidth <= screenSize.extraSmall ? "auto" : values.widthSubj,
      maxWidth:
        window.innerWidth <= screenSize.extraSmall ? "auto" : values.widthSubj,
      maxHeight: window.innerHeight * 0.9,
      top: window.innerHeight * 0.08,
      overflow: "auto",
    },
  },
};



// WEBPACK FOOTER //
// ./src/globals.js